import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "72",
  height: "72",
  viewBox: "0 0 72 72",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("title", null, "card-privacy-private-link", -1),
    _createElementVNode("path", {
      d: "M8 29v38h56V29H8zm8.5-5v-6c0-3.711 1.194-7.733 3.729-10.929C23.562 2.871 28.831.5 36 .5c7.169 0 12.438 2.37 15.771 6.571C54.306 10.267 55.5 14.29 55.5 18v6H69v48H3V24h13.5zm5 0h29v-6c0-6.944-4.408-12.5-14.5-12.5-10.092 0-14.5 5.556-14.5 12.5v6zM32 50.138c-1.813-1.204-3-3.206-3-5.471C29 40.985 32.134 38 36 38s7 2.985 7 6.667c0 2.265-1.187 4.267-3 5.471v5.957C40 57.147 39.105 58 38 58h-4c-1.105 0-2-.853-2-1.905v-5.957z",
      "fill-rule": "nonzero"
    }, null, -1)
  ]))]))
}
export default { render: render }